import React from 'react';

import cl from 'classnames';
import { isEmpty } from 'ramda';
import { useSelector } from 'react-redux';

import Icon from 'components/shared/Icon';
import DateOrDay from 'components/shared/Icon/icons/DateOrDay';
import Pencil from 'components/shared/Icon/icons/Pencil';
import Tooltip, { TooltipText } from 'components/shared/Tooltip';
import { EOrganizedBy } from 'detailsv2/structure';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';
import { featureFlagsSelector } from 'store/features/selectors';
import { isDefined } from 'utils/ramda';

import ActionsMenu from '../../../ActionsMenu';
import { ChooseStartDate } from '../../ChooseStartDate';
import { useChronologicalMode } from '../../functions';
import { CollapseButton } from '../../HeaderActionsButton/CollapseButton';
import { MagicImportButton } from '../../HeaderActionsButton/MagicImportButton/MagicImportButton';
import { useTimelineContext } from '../../TimelineContext';
import { ActionRefs } from '../EventCalendar.types';
import s from './index.module.css';
import { HeaderButton } from './shared/HeaderButton';

function Header(props: { actionsRefs: ActionRefs }) {
  const { startDate, organizedActions, bulkActions, organizedBy } = useChronologicalMode();
  const { isMiddleScreen, isTabletOrMobile } = useMediaBreakpoints();
  const calendarIconFill = isMiddleScreen ? '#EEEEEE' : 'transparent';
  const { selectedEvents } = useTimelineContext();
  const features = useSelector(featureFlagsSelector);
  const isMagicImportEnabled = features?.magicImport === true;

  return (
    <div className={s.container}>
      <div className={cl(s.containerItem, s.containerLeft)}>
        <div className={cl(s.containerItem)}>
          <CollapseButton withText={!isMiddleScreen} />
        </div>

        <div className={cl(s.containerItem)}>
          {organizedBy === EOrganizedBy.Date && <ChooseStartDate value={startDate as any} isDisabled={!startDate} />}
        </div>
      </div>

      <div className={cl(s.containerItem, s.containerRight)} ref={props.actionsRefs.btnRef}>
        <div>
          {organizedActions.map((action) =>
            action.isActive ? (
              <button
                key={action.id}
                className={s.datesButton}
                onClick={() => {
                  const next = organizedActions.find((a) => !a.isActive);
                  next?.onClick();
                }}
              >
                <Icon component={DateOrDay} className={s.icon} fill={calendarIconFill} />
                {!isMiddleScreen && <span className={s.organizedByText}>{action.title}</span>}
              </button>
            ) : null,
          )}
        </div>

        {!isTabletOrMobile && (
          <ActionsMenu
            actions={bulkActions}
            childrenWrapperClassName={s.bulkActionsWrapper}
            className={s.bulkActionsMenu}
            optionsClassName={s.bulkActionsOption}
            disabled={isEmpty(selectedEvents)}
            menuRef={props.actionsRefs.menuRef}
          >
            <HeaderButton
              className={s.bulkActions}
              leftIcon={<Icon component={Pencil} className={s.bulkActionsIcon} />}
              text="Bulk Actions"
              data-disabled={isEmpty(selectedEvents)}
              data-tip
              data-for="bulkActions"
            />
            <Tooltip disable={isDefined(selectedEvents)} id="bulkActions" variant="dark">
              <TooltipText>Use Shift + click to select events</TooltipText>
            </Tooltip>
          </ActionsMenu>
        )}

        {isMagicImportEnabled && <MagicImportButton />}
      </div>
    </div>
  );
}

export default Header;
